<template>
  <div class="home-view">
    <mainmenu :menuArray="['首页', '产品', '玩家中心','关于我们']" :selectMenu="menuSelect" @changeMenu="getMenu"></mainmenu>
    <transition :name="transitionName">
      <component v-bind:is="view" ></component>
    </transition>
    <div class="copyright">
      <div class="icp-class">沪文网文【2017】8448-627号 新出网证（沪）字70号</div>
      <div class="corp-name">Copyright © 2019 方寸信息科技有限公司</div>
<!--      /*玖派沪ICP备 18022497号-1*/-->
      <div class="icp-class">沪ICP备 19011041号-1</div>

    </div>
  </div>
</template>

<script>
import Mainmenu from './components/mainmenu'
import Mysite from './components/mysite'
import Myproduct from './components/myproduct'
import Myorder from './components/myorder'
import Mycorp from './components/mycorp'
export default {
  name: 'home',
  components: {Mainmenu, 'mysite': Mysite, 'product': Myproduct, 'order': Myorder, 'corp': Mycorp},
  data () {
    return {
      view: 'mysite',
      menuSelect: '首页',
      transitionName: ''
    }
  },
  methods: {
    getMenu (item) {
      // this.view = item
      this.menuSelect = item
      switch (item) {
        case '首页':
          this.view = 'mysite'
          break
        case '产品':
          this.view = 'product'
          break
        case '玩家中心':
          this.view = 'order'
          break
        case '关于我们':
          this.view = 'corp'
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
  .home-view{
    width: 100%;
    height: 100vh;
    flex-shrink: 0;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    position: relative;
    user-select: none;
  }
  .copyright{
    width: 100%;
    height: 3.56rem;
    background-color: black;
    justify-content: space-around;
    flex-direction: row;
    align-content: center;
    align-items: center;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    user-select: none;
  }
  .corp-name{
    font-size:1.31rem;
    font-weight:bold;
    line-height:1.69rem;
    color:rgba(255,255,255,1);
  }
  .icp-class{
    /*margin-right: 1rem;*/
    font-size:1.31rem;
    font-weight:bold;
    line-height:1.69rem;
    color:rgba(255,255,255,1);
    /*position: absolute;*/
    /*right: 0;*/
  }
  .slide-up-enter-active,
  .slide-up-leave-active{
    will-change: transform;
    transition: all 1500ms;
    position: absolute;
  }
  .slide-up-enter {
    /*opacity: 0;*/
    transform: translate3d(0, -100%, 0);
  }
  .slide-up-leave-active {
    /*opacity: 0;*/
    transform: translate3d(0, 100%, 0);
  }
</style>



// WEBPACK FOOTER //
// src/home.vue